// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2ZMY4","label":"SetPasswdForm_label__32pNo"};